module.exports = __webpack_public_path__ + "img/삿뽀로맥주.26085f9d.jpg";